(function(){
  if (window.__BOX_SMART_SEARCH_V436__) return;
  window.__BOX_SMART_SEARCH_V436__ = true;

  const INDEX_VERSION = 'v43-6-ipads-tablets-handle-fallback';
  const CACHE_KEY = 'BOX:smart-search:index:' + INDEX_VERSION;
  const CACHE_TTL = 1000 * 60 * 30;
  const MIN_CHARS = 2;
  const MAX_MODEL_CHOICES = 8;
  const MAX_SOURCE_MATCHES = 90;
  const LOADING_DELAY_MS = 220;
  let INDEX_PROMISE = null;
  const SCORE_CACHE = new Map();
  const PREHEAT_DELAY_MS = 500;

  const SEARCH_SOURCES = [
    {
      key:'fundas',
      handles:['fundas-para-celulares-1','fundas-para-celulares','fundas-celulares'],
      url:'/pages/fundas-celulares',
      icon:'case'
    },
    {
      key:'tablets',
      handles:['ipads-y-tablets','fundas-para-ipads-y-tablets-1','fundas-para-ipads-y-tablets','fundas-para-tablets-y-ipad-1','fundas-para-tablets-y-ipad'],
      url:'/pages/ipads-y-tablets',
      icon:'tablet'
    },
    {
      key:'accesorios',
      handles:['accesorios-1','accesorios'],
      url:'/pages/accesorios',
      icon:'glass-cam'
    },
    {
      key:'smartwatch',
      handles:['accesorios-para-smartwatch-1','accesorios-para-smartwatch','smartwatch-1','smartwatch'],
      url:'/pages/accesorios-smartwatch',
      icon:'watch'
    },
    {
      key:'cargadores',
      handles:['cargadores-y-cables-1','cargadores-y-cables'],
      url:'/pages/cargadores-y-cables',
      icon:'cable'
    }
  ];

  const NORMALIZE_CACHE = new Map();
  const QUERY_INFO_CACHE = new Map();
  const QUERY_VARIANT_CACHE = new Map();
  const PRODUCT_TEXT_CACHE = new WeakMap();
  const NORMALIZE_CACHE_MAX = 7000;
  const QUERY_CACHE_MAX = 180;

  /*
    Base V42 compilada desde base_errores_busqueda_BOX_v1.json.
    Los alias seguros se resuelven con mapas de frases, no con cientos de
    replace() consecutivos. Esto reduce trabajo por cada variante del catálogo.
  */
  const SHOW_CUSTOM_CASES = false;

  const GLOBAL_ALIAS_GROUPS = [["samsung",["sam sung","samgsung","samgung","samnsug","samnsung","samsang","samsing","samsng","samsnug","samsong","samsug","samsum","samsumg","samsun","samsungg","samung","sanmsung","sansun","sansung"]],["galaxy",["galacy","galasy","galax","galaxi","galaxyx","galaxyy","galazy","galxy"]],["apple",["apl","aple","aplle","appel","applee"]],["iphone",["a iphone","ai phone","aifon","aifone","aifonee","aiphon","aiphone","ayfon","ayfone","ayphone","i phone","ifon","ifone","ifonee","ipheon","iphn","iphne","iphoe","iphoen","iphon","iphonea","iphonee","ipon","ipone"]],["ipad",["aipad","aipads","i pad","ipad airr","ipad proo","ipadd","ipads","ipda"]],["airpods",["aipods","air pods","air pos","airpds","airpod","airpods proo","airpodss","airpords"]],["xiaomi",["shaomi","shiaomi","shiomi","xaiomi","xaomi","xiami","xiaomii","xiaomy","xioami","xiomi","xiomy"]],["redmi",["redme","redmii","redmy"]],["poco",["pocco","poccoo","pocoo","poko"]],["motorola",["moto rola","motorla","motorlaa","motorolaa","motorolla","mototola","motrola"]],["moto",["moto g","moto-g","motog","motoo"]],["huawei",["hauwei","huaway","huawe","huawey","huaweyy","huawuei","hwawei"]],["honor",["honnor","honorr","honr","onor"]],["oppo",["opo","opoo","oppoo","oppooo"]],["vivo",["bivo","viboo","vivoo"]],["realme",["real me","realmee","realmi","relame"]],["tecno",["techno","tecnoo","tekno"]],["infinix",["infinic","infinixs","infinixx","infinx","infnix","inifinix"]],["zte",["zete","ztc","zteee"]],["tcl",["t c l","tcll"]],["nokia",["nokiaa","nokya","noquia"]],["lenovo",["lenobo","lenov","lenovoo"]],["alcatel",["alcaltel","alcatell","alcatle"]],["oneplus",["1 plus","one +","one plus","onepluss"]],["pixel",["google pixel","googlepixel","pixcel","pixell","poxel"]],["pro max",["pro  max","pro maxx","pro-max","promax","promaxx"]],["max",["maxx"]],["pro",["proo"]],["plus",["+","pluss","plusss"]],["ultra",["ulta","ultar","ultraa","ultraaa","utlra"]],["mini",["minii","mni"]],["fe",["f e","fan edition"]],["lite",["lait","litee"]],["edge",["edg","edgee"]],["note",["notee","nott","notte"]],["se",["s e","special edition"]],["5g",["5 g","5-g","cinco g"]],["4g",["4 g","4-g","cuatro g"]],["funda",["carcasa","carcasas","case","cases","cover","covers","estuche","estuches","forro","forros","fundas"]],["funda personalizada",["carcasa personalizada","case personalizado","funda con foto","funda con imagen","funda impresa","fundas personalizadas"]],["hydrogel",["hidro gel","hidrogel","hidrogell","hydro gel","hydrogell","lamina hidrogel","lámina hydrogel","film","lamina","lámina","mica","pelicula","película","protector de pantalla","protector pantalla","protector para pantalla"]],["vidrio templado",["cristal","cristal templado","glass protector","mica de vidrio","protector de cristal","protector de vidrio","protector vidrio","tempered glass","templado","vidrio","vidrio de pantalla","vidrio para pantalla","vidrio pantalla","vidrio tempado","vidrio templao","vidrio templado con instalador","vidrio templadoo","vidrio templlado","vidrio tenplado","vidro templado"]],["anti espia",["anti spy","anti-espia","antiespia","antiespía","privacidad","privacy"]],["matte",["mat","mate","opaco"]],["clear",["cristalino","transparent","transparente"]],["glass cam",["glas cam","glas camera","glass camera","glasscam","lens protector","protector camara","protector cámara","protector de camara","protector de cámara","protector de lente","protector lente","vidrio camara","vidrio cámara"]],["cargador",["carga rapida","carga rápida","cargador completo","cargadores","charger","chargers"]],["cubo",["adaptador de corriente","brick","cabeza de cargador","cabezal","cubito","cubitos","cubos","power adapter"]],["cable",["cable cargador","cable de carga","cables","cordon","cordón"]],["cargador carro",["car charger","cargador auto","cargador de auto","cargador de carro","cargador para carro","cargador vehiculo","cargador vehículo"]],["ldnio",["ldn io","ldino","ldni0","ldn1o","ldnioo","l d n i o"]],["auriculares",["audifono","audifonos","audífono","audífonos","auricular","earbuds","earphones","headphones","headset","manos libres","tws"]],["smartwatch",["reloj inteligente","reloj smart","smart wach","smart watch","smartwatchh","wacth","watchh","watsh"]],["magsafe",["mag safe","mag-safe","magsefe","magseif"]],["tipo c",["tipo-c","type c","type-c","usb c","usb-c","usbc"]],["v8",["micro b","micro usb","micro-usb","microusb","usb micro","usb micro b","v 8","v-8"]],["lightning",["8 pin","8pin","cable iphone","cable para iphone","lighning","lighting","lightnig","ligthning"]],["usb a",["tipo a","type a","usb-a","usba"]],["otg",["adaptador otg","o t g"]],["w",["vatio","vatios","watt","watts"]],["mm",["milimetro","milimetros","milímetro","milímetros"]],["metro",["metros","mtr","mts"]],["cm",["centimetro","centimetros","centímetro","centímetros"]]];
  const SERVICE_ALIAS_GROUPS = [["orderstatus",["donde esta mi pedido","dónde está mi pedido","estado de mi pedido","guia","guía","rastrear pedido","seguimiento pedido","tracking","estado de pedido"]],["shipping",["costo de envio","cuanto cuesta el envio","entregas","envio","envio gratis","envios","envíos","envios"]],["returns",["cambio","cambios","devolucion","devolución","garantia","garantía","reembolso","cambios y garantias"]],["contact",["contactanos","contacto","contáctanos","correo","telefono","teléfono","whatsapp","contacto"]],["locations",["direccion","dirección","donde estan","dónde están","sucursales","tiendas","ubicacion","ubicación","ubicaciones"]],["hours",["a que hora abren","a qué hora abren","estan abiertos","están abiertos","hora de apertura","horario","horarios","horarios"]],["payments",["deposito","depósito","formas de pago","metodos de pago","métodos de pago","pago contra entrega","transferencia","metodos de pago"]]];
  const WATCH_ALIAS_GROUPS = [["pulsera watch",["banda","bandas","correa","correas","pulsera","pulseras","strap","watch band","watch strap"]],["bumper watch",["bumper","carcasa watch","case watch","protector watch"]]];
  const NO_FUZZY_TOKENS = new Set(['earpods']);
  const FUZZY_TERMS = ["accesorios","airpods","alcatel","apple","auriculares","cable","camara","cargador","edge","funda","galaxy","honor","huawei","hydrogel","infinix","ipad","iphone","lenovo","lightning","lite","magsafe","mini","motorola","nokia","note","oneplus","oppo","pantalla","personalizada","pixel","poco","protector","realme","redmi","samsung","smartwatch","tecno","templado","ultra","vidrio","vivo","xiaomi"];
  const STOPWORDS = new Set(["busco","buscar","quiero","necesito","dame","mostrar","muestrame","muéstrame","ver","tienen","tiene","hay","para","por","de","del","la","el","los","las","un","una","unos","unas","mi","mis","que","con","compatible","compatibilidad","sirve","servira","servirá","le queda","queda","modelo","telefono","teléfono","celular","movil","móvil","dispositivo","favor","por favor"]);

  function basicNormalize(value){
    return String(value || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, ' y ')
      .replace(/\+/g, ' plus ')
      .replace(/[’'`´]/g, ' ')
      .replace(/[_\/|.,:;()\[\]{}!?¿¡=]+/g, ' ')
      .replace(/-+/g, ' ')
      // Separa palabras pegadas frecuentes sin romper series como A26 o S25.
      .replace(/\b(iphone|ipad|galaxy|samsung|redmi|poco|xiaomi|motorola|moto|huawei|honor|oppo|vivo|realme|tecno|infinix|zte|tcl|nokia|lenovo|alcatel|oneplus|pixel)(\d)/g, '$1 $2')
      .replace(/(\d)(promax|pro|max|plus|mini|ultra|fe|lite|edge|mm|watts?|w|g)\b/g, '$1 $2')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function buildPhraseMap(groups){
    const map = new Map();
    let maxWords = 1;
    groups.forEach(function(group){
      const canonical = basicNormalize(group[0]);
      (group[1] || []).forEach(function(alias){
        const key = basicNormalize(alias);
        if (!key || key === canonical) return;
        map.set(key, canonical);
        maxWords = Math.max(maxWords, key.split(' ').length);
      });
    });
    return { map:map, maxWords:maxWords };
  }

  const GLOBAL_ALIAS_INDEX = buildPhraseMap(GLOBAL_ALIAS_GROUPS);
  const WATCH_ALIAS_INDEX = buildPhraseMap(WATCH_ALIAS_GROUPS);
  const SERVICE_ALIAS_INDEX = buildPhraseMap(SERVICE_ALIAS_GROUPS);

  function applyPhraseMap(value, index, changeLog){
    const words = basicNormalize(value).split(' ').filter(Boolean);
    if (!words.length) return '';
    const out = [];
    for (let i = 0; i < words.length;){
      let matched = false;
      const remaining = words.length - i;
      for (let size = Math.min(index.maxWords, remaining); size >= 1; size--){
        const phrase = words.slice(i, i + size).join(' ');
        const canonical = index.map.get(phrase);
        if (!canonical) continue;
        canonical.split(' ').forEach(function(w){ out.push(w); });
        if (changeLog && phrase !== canonical) changeLog.push([phrase, canonical]);
        i += size;
        matched = true;
        break;
      }
      if (!matched){ out.push(words[i]); i++; }
    }
    return out.join(' ');
  }

  function limitedDamerau(a, b, limit){
    a = String(a || '');
    b = String(b || '');
    if (a === b) return 0;
    if (!a || !b || Math.abs(a.length - b.length) > limit) return limit + 1;
    const prevPrev = new Array(b.length + 1).fill(0);
    const prev = new Array(b.length + 1);
    const curr = new Array(b.length + 1);
    for (let j = 0; j <= b.length; j++) prev[j] = j;
    for (let i = 1; i <= a.length; i++){
      curr[0] = i;
      let rowMin = curr[0];
      for (let j = 1; j <= b.length; j++){
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        let value = Math.min(prev[j] + 1, curr[j - 1] + 1, prev[j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]){
          value = Math.min(value, prevPrev[j - 2] + 1);
        }
        curr[j] = value;
        if (value < rowMin) rowMin = value;
      }
      if (rowMin > limit) return limit + 1;
      for (let j = 0; j <= b.length; j++){ prevPrev[j] = prev[j]; prev[j] = curr[j]; }
    }
    return prev[b.length];
  }

  function fuzzyCanonicalToken(token){
    const t = String(token || '');
    if (t.length < 4 || /\d/.test(t) || NO_FUZZY_TOKENS.has(t)) return '';
    const limit = t.length >= 7 ? 2 : 1;
    let best = '';
    let bestDistance = limit + 1;
    let tied = false;
    for (let i = 0; i < FUZZY_TERMS.length; i++){
      const candidate = FUZZY_TERMS[i];
      if (Math.abs(candidate.length - t.length) > limit) continue;
      const distance = limitedDamerau(t, candidate, limit);
      if (distance < bestDistance){ best = candidate; bestDistance = distance; tied = false; }
      else if (distance === bestDistance && distance <= limit && candidate !== best) tied = true;
    }
    return bestDistance <= limit && !tied ? best : '';
  }

  function applyContextualRules(value, changes){
    let text = ' ' + basicNormalize(value) + ' ';
    const replace = function(pattern, replacement, label){
      const before = text;
      text = text.replace(pattern, replacement);
      if (changes && before !== text) changes.push([label || String(pattern), replacement.trim()]);
    };

    replace(/\bpro\s+(?:mx|mas)\b/g, ' pro max ', 'pro mx/mas');
    replace(/\bpromx\b/g, ' pro max ', 'promx');
    replace(/\btipo\s+ce\b/g, ' tipo c ', 'tipo ce');
    replace(/\bcinco\s+g\b/g, ' 5g ', 'cinco g');
    replace(/\bcuatro\s+g\b/g, ' 4g ', 'cuatro g');
    const deviceContext = /\b(iphone|ipad|galaxy|samsung|xiaomi|redmi|poco|motorola|moto|huawei|honor|oppo|vivo|realme|tecno|infinix|zte|tcl|nokia|lenovo|alcatel|oneplus|pixel|a\d{1,3}|s\d{1,3}|g\d{1,3}|y\d{1,3}|c\d{1,3}|note\s*\d{1,3})\b/.test(text);
    const cableContext = /\b(cable|cargador|cubo|usb|tipo c|lightning|v8|micro|w|watt|watts|otg)\b/.test(text);
    const watchContext = /\b(watch|smartwatch|reloj|pulsera|correa|banda|bumper|mm)\b/.test(text);

    if (deviceContext){
      replace(/\b([asygc])\s+(\d{1,3})\b/g, ' $1$2 ', 'serie separada');
      replace(/\btipo\s+c(\d{1,3})\b/g, ' tipo c $1 ', 'proteger tipo c');
      replace(/\b(\d{1,3})\s+mx\b/g, ' $1 max ', 'número + mx');
      replace(/\b(\d{1,3})\s+pr\b/g, ' $1 pro ', 'número + pr');
      if (/\b(redmi|galaxy|samsung)\b/.test(text)) replace(/\bnot\s*(\d{1,3})\b/g, ' note $1 ', 'not + número');
    }
    if (cableContext) replace(/\btc\b/g, ' tipo c ', 'tc con contexto');
    if (watchContext) text = ' ' + applyPhraseMap(text, WATCH_ALIAS_INDEX, changes) + ' ';

    return basicNormalize(text);
  }

  function stripStopwords(value){
    const words = basicNormalize(value).split(' ').filter(Boolean);
    const filtered = words.filter(function(word){ return !STOPWORDS.has(word); });
    return filtered.length ? filtered.join(' ') : words.join(' ');
  }

  function detectServiceIntent(value){
    const text = basicNormalize(value);
    if (!text) return '';
    const words = text.split(' ');
    for (let i = 0; i < words.length; i++){
      for (let size = Math.min(SERVICE_ALIAS_INDEX.maxWords, words.length - i); size >= 1; size--){
        const hit = SERVICE_ALIAS_INDEX.map.get(words.slice(i, i + size).join(' '));
        if (hit) return hit;
      }
    }
    return '';
  }

  function queryInfo(value){
    const raw = String(value || '').trim();
    const cacheKey = raw.toLowerCase();
    if (QUERY_INFO_CACHE.has(cacheKey)) return QUERY_INFO_CACHE.get(cacheKey);
    if (QUERY_INFO_CACHE.size > QUERY_CACHE_MAX) QUERY_INFO_CACHE.clear();

    const basic = basicNormalize(raw);
    const changes = [];
    let normalized = applyPhraseMap(basic, GLOBAL_ALIAS_INDEX, changes);
    normalized = applyContextualRules(normalized, changes);

    const correctedWords = normalized.split(' ').filter(Boolean).map(function(word){
      const corrected = fuzzyCanonicalToken(word);
      if (corrected && corrected !== word){ changes.push([word, corrected]); return corrected; }
      return word;
    });
    normalized = stripStopwords(correctedWords.join(' '));

    const service = detectServiceIntent(applyPhraseMap(basic, GLOBAL_ALIAS_INDEX));
    const info = {
      raw:raw,
      basic:basic,
      normalized:normalized || basic,
      corrected:changes.length > 0,
      changes:changes,
      service:service
    };
    QUERY_INFO_CACHE.set(cacheKey, info);
    return info;
  }

  function normalize(value){
    const raw = String(value || '');
    if (NORMALIZE_CACHE.has(raw)) return NORMALIZE_CACHE.get(raw);
    if (NORMALIZE_CACHE.size > NORMALIZE_CACHE_MAX) NORMALIZE_CACHE.clear();
    const normalized = applyContextualRules(applyPhraseMap(basicNormalize(raw), GLOBAL_ALIAS_INDEX));
    NORMALIZE_CACHE.set(raw, normalized);
    return normalized;
  }
  function normalizeQuery(value){ return queryInfo(value).normalized; }
  function compact(value){ return normalize(value).replace(/\s+/g, ''); }
  function compactQuery(value){ return normalizeQuery(value).replace(/\s+/g, ''); }
  function tokens(value){ return normalize(value).split(' ').filter(Boolean); }
  function queryTokens(value){ return normalizeQuery(value).split(' ').filter(Boolean); }

  const QUERY_INTENT_WORDS = new Set(['funda','personalizada','hydrogel','glass','cam','protector','pantalla','camara','cargador','cable','cubo','ldnio','auriculares','smartwatch','watch','pulsera','banda','correa','bumper','accesorios','magsafe','anti','espia','matte','clear','vidrio','templado','cristal','instalador']);
  function queryModelCore(value){
    const words = queryTokens(value).filter(function(word){ return !QUERY_INTENT_WORDS.has(word); });
    return words.join(' ');
  }
  function queryVariants(value){
    const raw = String(value || '');
    if (QUERY_VARIANT_CACHE.has(raw)) return QUERY_VARIANT_CACHE.get(raw);
    if (QUERY_VARIANT_CACHE.size > QUERY_CACHE_MAX) QUERY_VARIANT_CACHE.clear();
    const info = queryInfo(raw);
    const variants = [info.normalized, queryModelCore(raw)].filter(Boolean);
    variants.slice().forEach(function(v){
      if (/\bsamsung\b/.test(v)) variants.push(v.replace(/\bsamsung\b/g, 'galaxy'));
      if (/\bgalaxy\b/.test(v)) variants.push(v.replace(/\bgalaxy\b/g, 'samsung'));
      if (/\bmotorola\b/.test(v)) variants.push(v.replace(/\bmotorola\b/g, 'moto'));
      if (/\bmoto\b/.test(v)) variants.push(v.replace(/\bmoto\b/g, 'motorola'));
      if (/\bapple\b/.test(v) && /\d/.test(v)) variants.push(v.replace(/\bapple\b/g, 'iphone'));

      /*
        Algunas consultas incluyen simultáneamente la marca matriz y la familia,
        mientras option1 suele guardar solo la familia comercial.
        Ej.: "Xiaomi Redmi Note 13" debe comparar también como "Redmi Note 13".
        Se agregan variantes, no se reemplaza la consulta original.
      */
      if (/\bxiaomi\b/.test(v) && /\b(redmi|poco)\b/.test(v)) {
        variants.push(v.replace(/\bxiaomi\b/g, ' '));
      }
      if (/\bsamsung\b/.test(v) && /\bgalaxy\b/.test(v)) {
        variants.push(v.replace(/\bsamsung\b/g, ' '));
      }
      if (/\bapple\b/.test(v) && /\b(iphone|ipad|airpods|watch)\b/.test(v)) {
        variants.push(v.replace(/\bapple\b/g, ' '));
      }
      if (/\bmotorola\b/.test(v) && /\bmoto\b/.test(v)) {
        variants.push(v.replace(/\bmotorola\b/g, ' '));
      }
    });
    const unique = Array.from(new Set(variants.map(basicNormalize).filter(Boolean)));
    QUERY_VARIANT_CACHE.set(raw, unique);
    return unique;
  }
  function escapeHtml(value){ return String(value || '').replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function encodeParam(value){ return encodeURIComponent(String(value || '').trim()); }
  function displayLabel(value){ return String(value || '').replace(/\s+/g, ' ').replace(/\s*\/\s*/g, ' / ').trim(); }
  function isBadSuggestionLabel(label){
    const n = normalize(label);
    if (!n) return true;
    // Evita que productos internos o nombres de diseño aparezcan como modelos sugeridos.
    if (/\bparte\s*\d+\b/.test(n)) return true;
    if (/\bsilicon\s*diseno\b/.test(n)) return true;
    if (/\bdiseno\b/.test(n) && /\b\d{1,2}\b/.test(n) && !/\b(iphone|galaxy|samsung|redmi|xiaomi|ipad|moto|huawei|honor|oppo|vivo|realme|tecno|infinix)\b/.test(n)) return true;
    return false;
  }
  function uniqueBy(arr, keyFn){
    const seen = new Set();
    return arr.filter(function(item){ const key = keyFn(item); if(seen.has(key)) return false; seen.add(key); return true; });
  }
  function isHiddenVariant(variant){ return String(variant && variant.sku || '').toLowerCase().includes('error'); }
  function isAvailableVariant(variant){
    if (!variant) return false;
    if (variant.available === true) return true;
    if (typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0) return true;
    return false;
  }
  function optionValues(product, variant){
    return [variant && variant.option1, variant && variant.option2, variant && variant.option3]
      .concat([product && product.vendor, product && product.title, product && product.product_type, product && product.tags])
      .filter(Boolean).map(function(v){ return Array.isArray(v) ? v.join(' ') : String(v); });
  }
  function sourceText(product, variant){ return optionValues(product, variant).join(' '); }

  function editDistanceLimited(a, b, limit){
    return limitedDamerau(a, b, limit);
  }

  function tokenFuzzyHit(token, candidateTokens){
    const t = compact(token);
    if (!t || t.length < 4 || NO_FUZZY_TOKENS.has(t)) return false;
    for (const c of candidateTokens){
      const cc = compact(c);
      if (!cc || cc.length < 4) continue;
      if (cc.startsWith(t) || t.startsWith(cc)) return true;
      const limit = t.length >= 8 ? 3 : (t.length >= 5 ? 2 : 1);
      if (editDistanceLimited(t, cc, limit) <= limit) return true;
    }
    return false;
  }



  function isLikelyBrandToken(token){
    const t = compact(token);
    if (!t) return false;
    const brands = ['samsung','galaxy','iphone','apple','ipad','xiaomi','redmi','poco','motorola','moto','huawei','honor','oppo','vivo','realme','tecno','infinix','zte','tcl','nokia','lenovo','alcatel','oneplus','pixel'];
    return brands.some(function(b){
      if (t === b || b.startsWith(t) || t.startsWith(b)) return true;
      const limit = Math.max(t.length, b.length) >= 7 ? 2 : 1;
      return editDistanceLimited(t, b, limit) <= limit;
    });
  }

  function queryWithoutLikelyBrand(query){
    const kept = queryTokens(query).filter(function(t){ return !isLikelyBrandToken(t); });
    return kept.join(' ');
  }

  function bestFallbackLabel(product, variant, query){
    const raw = [variant && variant.option1, variant && variant.option2, variant && variant.option3, product && product.title]
      .filter(Boolean)
      .map(displayLabel)
      .filter(function(label){ return !isBadSuggestionLabel(label); });
    const qNoBrand = queryWithoutLikelyBrand(query) || query;
    const scored = raw.map(function(label){
      return { label: label, score: Math.max(scoreCandidateText(label, qNoBrand), scoreCandidateText(label, query)) };
    }).filter(function(x){ return x.score > 0; });
    scored.sort(function(a,b){
      return b.score - a.score || modelRank(a.label, qNoBrand) - modelRank(b.label, qNoBrand) || a.label.length - b.label.length;
    });
    return scored.length ? scored[0].label : '';
  }

  function suggestedLabelFromMatches(matches, query){
    const list = matches || [];

    /*
      Cuando existe una coincidencia exacta, todas las rutas derivadas (por ejemplo,
      Hydrogel) deben reutilizar exactamente el mismo modelo encontrado en option1.
      Así, una búsqueda como "17 pro max" no termina usando "IPHONE 17.".
    */
    const exact = list
      .filter(function(match){ return match && isExactModelLabel(match.label, query); })
      .sort(function(a,b){
        return b.score - a.score || a.label.length - b.label.length;
      })[0];

    if (exact && exact.label) return exact.label;

    const top = topLabels(list, query, 1)[0];
    return top && top.label ? top.label : displayLabel(query);
  }

  function scoreOneNormalizedCandidate(cNorm, qNorm){
    const qCompact = qNorm.replace(/\s+/g, '');
    const cCompact = cNorm.replace(/\s+/g, '');
    if (!qNorm || !cNorm) return 0;
    if (cCompact === qCompact) return 260;
    if (cNorm === qNorm) return 255;
    if (cCompact.startsWith(qCompact)) return 210;
    if (cCompact.includes(qCompact)) return 170;

    const qTokens = qNorm.split(' ').filter(Boolean);
    const cTokens = cNorm.split(' ').filter(Boolean);
    if (!qTokens.length) return 0;
    let score = 0;
    let fuzzyUsed = 0;
    for (const token of qTokens){
      const tokenCompact = token.replace(/\s+/g, '');
      const tokenHit = cTokens.includes(token);
      const compactHit = cCompact.includes(tokenCompact);
      if (tokenHit) score += 32;
      else if (compactHit) score += 26;
      else if (tokenFuzzyHit(token, cTokens)) { score += 18; fuzzyUsed += 1; }
      else return 0;
    }
    return Math.max(0, score - fuzzyUsed * 4);
  }

  function scoreCandidateText(candidateText, query){
    const cacheKey = String(candidateText || '') + '||' + String(query || '');
    if (SCORE_CACHE.has(cacheKey)) return SCORE_CACHE.get(cacheKey);
    if (SCORE_CACHE.size > 6000) SCORE_CACHE.clear();
    const cNorm = normalize(candidateText);
    const variants = queryVariants(query);
    let best = 0;
    for (let i = 0; i < variants.length; i++){
      best = Math.max(best, scoreOneNormalizedCandidate(cNorm, variants[i]));
      if (best >= 260) break;
    }
    SCORE_CACHE.set(cacheKey, best);
    return best;
  }
  function modelRank(label, query){
    const lc = normalize(label);
    const qc = compactQuery(query);
    const cc = compact(label);
    let exact = cc === qc ? 0 : (cc.startsWith(qc) ? 1 : 2);
    let tier = 50;
    if (/\bpro max\b/.test(lc)) tier = 4;
    else if (/\bpro\b/.test(lc)) tier = 3;
    else if (/\bplus\b/.test(lc)) tier = 2;
    else if (/\bmini\b/.test(lc)) tier = 5;
    else tier = 1;
    return exact * 100 + tier;
  }

  function brandPrefixForQuery(query){
    const q = normalizeQuery(query);
    if (/\biphone\b/.test(q)) return 'iphone';
    if (/\bipad\b/.test(q)) return 'ipad';
    if (/\bgalaxy\b/.test(q)) return 'galaxy';
    if (/\btab\b/.test(q)) return 'tab';
    if (/\bredmi\b/.test(q)) return 'redmi';
    if (/\bpoco\b/.test(q)) return 'poco';
    if (/\bxiaomi\b/.test(q)) return 'xiaomi';
    if (/\bmoto\b|\bmotorola\b/.test(q)) return 'moto';
    if (/\bhuawei\b/.test(q)) return 'huawei';
    if (/\bhonor\b/.test(q)) return 'honor';
    if (/\boppo\b/.test(q)) return 'oppo';
    if (/\bvivo\b/.test(q)) return 'vivo';
    if (/\brealme\b/.test(q)) return 'realme';
    if (/\btecno\b/.test(q)) return 'tecno';
    if (/\binfinix\b/.test(q)) return 'infinix';
    if (/\bzte\b/.test(q)) return 'zte';
    if (/\btcl\b/.test(q)) return 'tcl';
    if (/\bnokia\b/.test(q)) return 'nokia';
    if (/\blenovo\b/.test(q)) return 'lenovo';
    if (/\balcatel\b/.test(q)) return 'alcatel';
    if (/\boneplus\b/.test(q)) return 'oneplus';
    if (/\bpixel\b/.test(q)) return 'pixel';
    return '';
  }
  function expandedSegments(label, query){
    const raw = String(label || '').replace(/[.]+$/g, '').trim();
    const qPrefix = brandPrefixForQuery(query);
    const parts = raw.split(/\s*\/\s*|\s*\|\s*|\s*,\s*/).map(displayLabel).filter(Boolean);
    const out = new Set([normalize(raw)]);
    parts.forEach(function(part){
      const n = normalize(part);
      out.add(n);
      if (qPrefix && !n.includes(qPrefix)) out.add(normalize(qPrefix + ' ' + n));
    });
    return Array.from(out);
  }
  function modelCore(value, asQuery){
    const source = asQuery ? normalizeQuery(value) : normalize(value);
    return source
      .replace(/\b(samsung|galaxy|apple|iphone|ipad|tablet|tablets|tab|xiaomi|redmi|poco|motorola|moto|huawei|honor|oppo|vivo|realme|tecno|infinix|zte|tcl|nokia|lenovo|alcatel|oneplus|pixel)\b/g, ' ')
      .replace(/\b(funda|personalizada|hydrogel|glass|cam|protector|pantalla|camara|cargador|cable|cubo|auriculares|smartwatch|watch|pulsera|bumper|accesorios|magsafe|anti|espia|matte|clear)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function modelTier(value){
    const n = normalize(value);
    if (/\bpro\s*max\b/.test(n)) return 'pro max';
    if (/\bpro\b/.test(n)) return 'pro';
    if (/\bplus\b/.test(n)) return 'plus';
    if (/\bmini\b/.test(n)) return 'mini';
    if (/\bfe\b/.test(n)) return 'fe';
    if (/\bedge\b/.test(n)) return 'edge';
    if (/\bultra\b/.test(n)) return 'ultra';
    return 'standard';
  }
  function basePrefixFromFirstSegment(firstSegment){
    const n = normalize(firstSegment);
    const m = n.match(/^((?:iphone|ipad|galaxy|samsung|redmi|poco|xiaomi|huawei|honor|moto|motorola|oppo|vivo|realme|tecno|infinix|zte|tcl|nokia|lenovo|alcatel|oneplus|pixel|tab)\s*)/i);
    return m ? m[1].trim() : '';
  }
  function dotDelimitedSegments(label){
    const raw = String(label || '').trim();
    const beforeDot = raw.includes('.') ? raw.split('.')[0] : raw;
    const clean = displayLabel(beforeDot);
    const pieces = clean.split(/\s*\/\s*|\s*\|\s*|\s*,\s*/).map(displayLabel).filter(Boolean);
    const prefix = basePrefixFromFirstSegment(pieces[0] || clean);
    const expanded = pieces.map(function(piece, index){
      const n = normalize(piece);
      if (index > 0 && prefix && !/\b(iphone|ipad|galaxy|samsung|redmi|poco|xiaomi|huawei|honor|moto|motorola|oppo|vivo|realme|tecno|infinix|zte|tcl|nokia|lenovo|alcatel|oneplus|pixel|tab)\b/.test(n)) {
        return displayLabel(prefix + ' ' + piece);
      }
      return piece;
    });
    return uniqueBy(expanded.filter(Boolean), function(x){ return compact(modelCore(x)); });
  }
  function isDotDelimitedExact(label, query){
    const qCore = compact(modelCore(query, true));
    if (!qCore || !label) return false;

    const segments = dotDelimitedSegments(label);
    if (!segments.length) return false;

    const qTier = modelTier(query);
    const matching = segments.filter(function(seg){ return compact(modelCore(seg)) === qCore; });
    if (!matching.length) return false;

    if (segments.length === 1) return true;

    // Compatibilidades agrupadas: son "más probables" solo si todos los segmentos
    // pertenecen a la misma variante/tier. Ej.: iPhone 13 / 14 / 15 sí;
    // iPhone 13 / 13 Pro no, porque mezcla estándar con Pro.
    return segments.every(function(seg){ return modelTier(seg) === qTier; });
  }
  function isExactModelLabel(label, query){
    const qCore = compact(modelCore(query, true));
    const labelCompact = compact(label);
    const queryCompact = compactQuery(query);
    if (!qCore || !label) return false;
    if (labelCompact === queryCompact) return true;
    return isDotDelimitedExact(label, query);
  }
  function isRelatedModelLabel(label, query){
    if (!label || !query) return false;
    if (isExactModelLabel(label, query)) return false;
    const qTokens = queryTokens(query);
    const labelNorm = normalize(label);
    const labelCompact = compact(label);
    const queryCompact = compactQuery(query);
    if (labelCompact.includes(queryCompact)) return true;
    return qTokens.length && qTokens.every(function(t){ return labelNorm.split(' ').includes(t) || labelCompact.includes(compact(t)); });
  }
  function queryLooksLikeDeviceModel(query){
    const q = normalizeQuery(query);
    if (!q) return false;
    const intent = queryIntent(query);
    if (intent.cable || intent.airpods || intent.auriculares || intent.watch) return false;

    /* Permite buscar el modelo sin escribir la marca: 17 pro max, 15 pro, 14 plus, etc. */
    if (/\b\d{1,3}\s+(?:pro\s*max|pro|plus|mini|ultra|fe|lite|edge)\b/.test(q)) return true;

    return /\b(iphone|galaxy|samsung|redmi|xiaomi|poco|moto|motorola|huawei|honor|oppo|vivo|realme|tecno|infinix|zte|tcl|nokia|lenovo|alcatel|oneplus|pixel|ipad|tab|a\d{1,2}|s\d{1,2}|note\s*\d{1,2}|g\d{1,2}|y\d{1,2}|c\d{1,2}|nova\s*\d{1,2})\b/.test(q);
  }

  function productTypeText(product){
    if (!product) return '';
    if (PRODUCT_TEXT_CACHE.has(product)) return PRODUCT_TEXT_CACHE.get(product);
    const value = normalize([product.title, product.product_type, product.tags].filter(Boolean).join(' '));
    PRODUCT_TEXT_CACHE.set(product, value);
    return value;
  }
  function accessoryType(product){
    const text = productTypeText(product);
    if (/glass\s*cam|camara|camera|lente|lens/.test(text)) return 'GLASS CAM';
    if (/airpods|air pods/.test(text)) return 'AIRPODS';
    if (/auricular|audifono|audifonos|earphone|headphone|tws/.test(text)) return 'AURICULARES';
    return 'ACCESORIOS';
  }
  function queryIntent(query){
    const q = normalizeQuery(query);
    const power = /(?:^|\b)\d{1,3}\s*w(?:\b|$)|\bwatts?\b/.test(q);
    const chargerBrand = /\b(ldnio|hoco|joyroom|kuulaa|xo|awei|anker|baseus|essager)\b/.test(q);
    const chargerModel = /\ba\d{3,5}c?\b/.test(q);
    const cable = power || chargerBrand || chargerModel || /\b(tipo c|usb|lightning|cable|cargador|cubo|cubito|v8|micro|microusb|otg)\b/.test(q);
    const airpods = /\b(airpods|air pods|airpod)\b/.test(q);
    const auriculares = /\b(auricular|auriculares|audifono|audifonos|tws)\b/.test(q);
    const watchSize = /\b(?:3[89]|4[0-9])\s*mm\b/.test(q) || /\bpin\s*(?:20|22)\s*mm\b/.test(q);
    const watch = watchSize || /\b(watch|reloj|smartwatch|pulsera|pulsera watch|banda|bandas|correa|correas|bumper|bumper watch)\b/.test(q);
    const tablet = /\b(ipad|tab|tablet|tablets|libreta)\b/.test(q);
    const camera = /\b(glass cam|protector camara|protector de camara|camara|camera|lente|lens)\b/.test(q);
    const temperedGlass = !camera && (
      /\b(vidrio templado|protector de vidrio|protector vidrio|vidrio para pantalla|vidrio de pantalla|cristal templado|protector de cristal|tempered glass|glass protector)\b/.test(q) ||
      /\b(vidrio|templado|cristal)\b/.test(q)
    );
    const hydrogel = !temperedGlass && (/\b(hydrogel|protector pantalla|protector de pantalla|protector para pantalla|lamina|lamina protectora|mica|antiespia|anti espia|privacidad|matte|mate)\b/.test(q) || /^clear$/.test(q));
    const magsafe = /\b(magsafe|mag safe)\b/.test(q);
    const caseFeature = magsafe || /\b(funda|fundas|case|cases)\b/.test(q);
    return { cable, power, airpods, auriculares, watch, tablet, camera, temperedGlass, hydrogel, magsafe, caseFeature, device: !cable && !airpods && !auriculares && !watch && !temperedGlass && !hydrogel && !camera };
  }

  function cleanFeatureModelQuery(query, type){
    let s = String(query || '');
    if (type === 'hydrogel') {
      s = s.replace(/hydrogel|protector\s+(de\s+|para\s+)?pantalla|lamina\s+protectora|lamina|mica|pelicula|film|anti\s*espia|antiespia|privacidad|matte|mate|clear/ig, ' ');
    }
    if (type === 'camera') {
      s = s.replace(/glass\s*cam|protector\s+(de\s+)?camara|camara|camera|lente|lens/ig, ' ');
    }
    if (type === 'tempered-glass') {
      s = s.replace(/vidrio\s*templado|vidrio\s*tenplado|vidro\s*templado|cristal\s*templado|protector\s+(de\s+)?vidrio|protector\s+(de\s+)?cristal|vidrio\s+(de\s+|para\s+)?pantalla|tempered\s*glass|glass\s*protector|\bvidrio\b|\btemplado\b|\bcristal\b|con\s+instalador|instalador/ig, ' ');
    }
    return displayLabel(s.replace(/\s+/g, ' ').trim());
  }

  function featureRouteCard(kind, query){
    const model = cleanFeatureModelQuery(query, kind);
    if (kind === 'hydrogel') {
      const hasModel = model && model.length >= 2;
      return {
        key:'hydrogel-feature-' + compact(model || query),
        icon:'hydrogel',
        strength:'exact',
        badge:'Más probable',
        title: hasModel ? 'Hydrogel para “' + displayLabel(model) + '”' : 'Hydrogel para celulares y tablets',
        text: hasModel ? 'Elige tipo, marca y modelo para confirmar compatibilidad.' : 'Protector de pantalla a la medida. Elige tipo, marca y modelo.',
        url: hasModel ? '/pages/hydrogel?modelo_sugerido=' + encodeParam(model) : '/pages/hydrogel?q=' + encodeParam(query)
      };
    }
    if (kind === 'tempered-glass') {
      const hasModel = model && model.length >= 2;
      const params = ['vidrio=1'];
      if (hasModel) params.push('modelo_vidrio=' + encodeParam(model));
      return {
        key:'tempered-glass-' + compact(model || query),
        icon:'glass-screen',
        strength:'exact',
        badge:'Alternativa',
        title: hasModel ? 'Vidrio templado para “' + displayLabel(model) + '”' : 'Vidrio templado para pantalla',
        text: hasModel ? 'Confirma el modelo disponible y agrégalo directamente al carrito.' : 'Consulta los modelos disponibles y compra desde el selector.',
        url:'/pages/hydrogel?' + params.join('&') + '#vidrio-templado'
      };
    }
    if (kind === 'camera') {
      const hasModel = model && model.length >= 2;
      return {
        key:'glasscam-feature-' + compact(model || query),
        icon:'glass-cam',
        strength:'exact',
        badge:'Más probable',
        title: hasModel ? 'Glass Cam para “' + displayLabel(model) + '”' : 'Glass Cam para cámara',
        text: hasModel ? 'Protección compatible para la cámara trasera.' : 'Protectores para cámara trasera según modelo disponible.',
        url: hasModel ? '/pages/accesorios?tipo=GLASS%20CAM&modelo=' + encodeParam(model) : '/pages/accesorios?tipo=GLASS%20CAM&q=' + encodeParam(query)
      };
    }
    return null;
  }
  function isBroadDeviceQuery(query){
    const q = normalizeQuery(query);
    if (/\b(pro max|pro|plus|mini|ultra|fe|lite)\b/.test(q)) return false;
    return /\b(iphone|galaxy|samsung|redmi|xiaomi|poco|moto|motorola|huawei|honor|oppo|vivo|realme|tecno|infinix|zte|tcl|nokia|lenovo|alcatel|oneplus|pixel|ipad|tab)\b/.test(q);
  }

  async function fetchCollectionHandle(handle){
    const all = [];
    for (let page = 1; page <= 5; page++){
      try{
        const res = await fetch('/collections/' + handle + '/products.json?limit=250&page=' + page, {
          credentials:'same-origin',
          cache:'no-store'
        });
        if (!res.ok) break;
        const json = await res.json();
        const products = (json && json.products) || [];
        if (!products.length) break;
        all.push.apply(all, products);
        if (products.length < 250) break;
      }catch(e){ break; }
    }
    return all;
  }

  async function fetchCollection(source){
    const handles = Array.isArray(source && source.handles)
      ? source.handles.filter(Boolean)
      : [source && source.handle].filter(Boolean);

    for (const handle of handles){
      const products = await fetchCollectionHandle(handle);
      if (products.length) return products;
    }
    return [];
  }
  function indexLooksHealthy(data){
    if (!data) return false;
    // Fundas y accesorios son las fuentes más importantes para que el buscador no se quede vacío.
    // Si alguna quedó en 0 por una carga interrumpida, no usamos ese caché.
    const fundasOk = Array.isArray(data.fundas) && data.fundas.length > 0;
    const accesoriosOk = Array.isArray(data.accesorios) && data.accesorios.length > 0;
    return fundasOk || accesoriosOk;
  }

  async function buildFreshIndex(){
    const data = {};
    await Promise.all(SEARCH_SOURCES.map(async function(source){
      data[source.key] = await fetchCollection(source);
    }));
    if (indexLooksHealthy(data)) {
      try{ localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: data })); }catch(e){}
    }
    return data;
  }

  async function getIndex(forceFresh){
    if (!forceFresh){
      try{
        const raw = localStorage.getItem(CACHE_KEY);
        if (raw){
          const cached = JSON.parse(raw);
          if (cached && cached.ts && Date.now() - cached.ts < CACHE_TTL && indexLooksHealthy(cached.data)) return cached.data;
        }
      }catch(e){}
      if (INDEX_PROMISE) return INDEX_PROMISE;
    }
    INDEX_PROMISE = buildFreshIndex().finally(function(){ INDEX_PROMISE = null; });
    return INDEX_PROMISE;
  }

  function labelCandidates(product, variant, query, sourceKey){
    /*
      Se conserva el mismo motor de puntuación, orden, coincidencias exactas,
      relacionadas y fuzzy. El único cambio estructural para modelos es:
      antes Modelo = option2; ahora Modelo = option1.
    */
    const intent = queryIntent(query);
    let raw;

    if (sourceKey === 'cargadores') {
      // En cargadores sí se buscan también color, medida, potencia y título.
      raw = [variant && variant.option1, variant && variant.option2, variant && variant.option3, product && product.title];
    } else if (sourceKey === 'accesorios' && (intent.airpods || intent.auriculares)) {
      // Mantiene la búsqueda por nombre comercial para productos de audio.
      raw = [variant && variant.option1, product && product.title];
    } else {
      // Fundas, tablets, Glass Cam y SmartWatch: el modelo vive únicamente en option1.
      raw = [variant && variant.option1];
    }

    const cleaned = raw
      .filter(Boolean)
      .map(displayLabel)
      .filter(function(label){ return !isBadSuggestionLabel(label); });

    const scored = cleaned
      .map(function(label){ return { label: label, score: scoreCandidateText(label, query) }; })
      .filter(function(x){ return x.score > 0; });

    /* El respaldo amplio se conserva únicamente para cargadores y cables. */
    if (!scored.length && sourceKey === 'cargadores'){
      const fullScore = scoreCandidateText(sourceText(product, variant), query);
      const fallbackLabel = bestFallbackLabel(product, variant, query);
      if (fullScore > 0 && fallbackLabel) scored.push({ label: fallbackLabel, score: Math.max(1, fullScore - 40) });
    }

    scored.sort(function(a,b){
      return b.score - a.score || modelRank(a.label, query) - modelRank(b.label, query) || a.label.length - b.label.length;
    });
    return uniqueBy(scored, function(x){ return compact(x.label); });
  }

  function sourceAllowed(sourceKey, product, query){
    const intent = queryIntent(query);
    const accType = sourceKey === 'accesorios' ? accessoryType(product) : null;

    if (sourceKey === 'fundas' && (intent.cable || intent.airpods || intent.auriculares || intent.watch || intent.tablet || intent.camera || intent.hydrogel)) return { ok:false, accType:null };
    if (sourceKey === 'tablets' && (intent.cable || intent.airpods || intent.auriculares || intent.watch || intent.camera || intent.hydrogel || !intent.tablet)) return { ok:false, accType:null };
    if (sourceKey === 'smartwatch' && !intent.watch) return { ok:false, accType:null };
    if (sourceKey === 'cargadores' && !intent.cable) return { ok:false, accType:null };
    if (sourceKey === 'accesorios'){
      if (intent.cable || intent.watch || intent.hydrogel) return { ok:false, accType:null };
      if (intent.airpods && accType !== 'AIRPODS') return { ok:false, accType:null };
      if (intent.auriculares && accType !== 'AURICULARES') return { ok:false, accType:null };
      if (intent.camera && accType !== 'GLASS CAM') return { ok:false, accType:null };
      if (!intent.airpods && !intent.auriculares && !intent.camera && accType !== 'GLASS CAM') return { ok:false, accType:null };
    }
    return { ok:true, accType:accType };
  }

  function findMatches(products, query, sourceKey){
    const matches = [];
    const list = products || [];
    for (let pIndex = 0; pIndex < list.length; pIndex++){
      if (matches.length >= MAX_SOURCE_MATCHES) break;
      const product = list[pIndex];
      const allowed = sourceAllowed(sourceKey, product, query);
      if (!allowed.ok) continue;
      const variants = Array.isArray(product.variants) ? product.variants : [];
      for (let vIndex = 0; vIndex < variants.length; vIndex++){
        if (matches.length >= MAX_SOURCE_MATCHES) break;
        const variant = variants[vIndex];
        if (isHiddenVariant(variant) || !isAvailableVariant(variant)) continue;
        const labels = labelCandidates(product, variant, query, sourceKey);
        for (let lIndex = 0; lIndex < labels.length; lIndex++){
          const item = labels[lIndex];
          matches.push({ product:product, variant:variant, score:item.score, label:item.label, accType:allowed.accType });
          if (matches.length >= MAX_SOURCE_MATCHES) break;
        }
      }
      if (!variants.length && matches.length < MAX_SOURCE_MATCHES){
        const score = scoreCandidateText(productTypeText(product), query);
        if (score > 0) matches.push({ product:product, variant:null, score:score, label:displayLabel(query), accType:allowed.accType });
      }
    }
    return uniqueBy(matches.sort(function(a,b){
      return b.score - a.score || modelRank(a.label, query) - modelRank(b.label, query) || a.label.length - b.label.length;
    }), function(m){ return sourceKey + '|' + compact(m.label) + '|' + (m.accType || ''); });
  }

  function topLabels(matches, query, limit){
    const grouped = new Map();
    matches.forEach(function(m){
      const key = compact(m.label);
      const old = grouped.get(key);
      if (!old || m.score > old.score) grouped.set(key, m);
    });
    return Array.from(grouped.values()).sort(function(a,b){
      return modelRank(a.label, query) - modelRank(b.label, query) || b.score - a.score || a.label.length - b.label.length;
    }).slice(0, limit || MAX_MODEL_CHOICES);
  }

  function chargerQueryAlias(query){
    const q = normalizeQuery(query);
    if (/\bv8\b/.test(q)) return 'V8';
    return query;
  }

  function cardForSource(sourceKey, match, query){
    const label = displayLabel(match && match.label || query);
    const strength = match && match.exact ? 'exact' : (match && match.related ? 'related' : 'normal');
    const badge = strength === 'exact' ? 'Más probable' : '';
    const withMeta = function(card){ return Object.assign({ strength: strength, badge: badge }, card); };
    if (sourceKey === 'fundas'){
      return withMeta({ key:'fundas-' + compact(label), icon:'case', title:'Fundas para “' + label + '”', text: strength === 'exact' ? 'Modelos y diseños compatibles disponibles.' : 'Puede ser compatible si este es tu modelo exacto.', url:'/pages/fundas-celulares?modelo=' + encodeParam(label) });
    }
    if (sourceKey === 'tablets'){
      return withMeta({ key:'tablets-' + compact(label), icon:'tablet', title:'Fundas para “' + label + '”', text: strength === 'exact' ? 'Fundas compatibles disponibles para este modelo.' : 'Puede ser compatible si este es tu iPad o tablet exacto.', url:'/pages/ipads-y-tablets?modelo=' + encodeParam(label) });
    }
    if (sourceKey === 'smartwatch'){
      return withMeta({ key:'smartwatch-' + compact(label), icon:'watch', title:'SmartWatch para “' + label + '”', text: strength === 'exact' ? 'Accesorios compatibles disponibles para este modelo.' : 'Pulseras, bumpers y combos compatibles.', url:'/pages/accesorios-smartwatch?modelo=' + encodeParam(label) });
    }
    if (sourceKey === 'accesorios'){
      if (match && match.accType === 'GLASS CAM') return withMeta({ key:'glass-cam-' + compact(label), icon:'glass-cam', title:'Glass Cam para “' + label + '”', text: strength === 'exact' ? 'Protección compatible para la cámara trasera.' : 'Puede ser compatible si este es tu modelo exacto.', url:'/pages/accesorios?tipo=GLASS%20CAM&modelo=' + encodeParam(label) });
      if (match && match.accType === 'AIRPODS') return withMeta({ key:'airpods-' + compact(label), icon:'airpods', title:'Accesorios para “' + label + '”', text:'Opciones disponibles para este modelo de AirPods.', url:'/pages/accesorios?tipo=AIRPODS&modelo=' + encodeParam(label) });
      if (match && match.accType === 'AURICULARES') return withMeta({ key:'auriculares-' + compact(query), icon:'audio', title:'Auriculares disponibles', text:'Opciones de audio disponibles.', url:'/pages/accesorios?tipo=AURICULARES&q=' + encodeParam(query) });
    }
    if (sourceKey === 'cargadores'){
      const qAlias = chargerQueryAlias(query);
      const hasV8 = normalizeQuery(qAlias) === 'v8';
      return withMeta({ key:'cargadores', icon:'cable', title: hasV8 ? 'Cargadores y cables V8 / Micro USB' : 'Cargadores y cables', text: hasV8 ? 'Opciones con conexión V8, también conocida como micro USB.' : 'Cables, cubos, Tipo C, Lightning y V8.', url:'/pages/cargadores-y-cables?q=' + encodeParam(qAlias) });
    }
    return null;
  }
  function sortExactThenRelated(matches, query){
    const correctedQuery = queryInfo(query).corrected;
    const list = topLabels(matches, query, 30).map(function(m){
      const exact = !correctedQuery && isExactModelLabel(m.label, query);
      const related = correctedQuery ? m.score > 0 : isRelatedModelLabel(m.label, query);
      return Object.assign({}, m, { exact: exact, related: related });
    }).filter(function(m){ return m.exact || m.related || m.score > 0; });
    list.sort(function(a,b){
      const ax = a.exact ? 0 : 1;
      const bx = b.exact ? 0 : 1;
      return ax - bx || modelRank(a.label, query) - modelRank(b.label, query) || b.score - a.score || a.label.length - b.label.length;
    });
    return list;
  }
  const SERVICE_CARD_DATA = {
    orderstatus:{ icon:'order', title:'Consultar el estado de mi pedido', text:'Déjanos tu número de pedido y te ayudamos a localizarlo.', url:'/pages/contactanos?motivo=estado-de-mi-pedido' },
    shipping:{ icon:'shipping', title:'Consultar envíos y tarifas', text:'Revisa costos, tiempos estimados e intentos de entrega.', url:'/policies/shipping-policy' },
    returns:{ icon:'shield', title:'Cambios, garantías y reembolsos', text:'Consulta plazos, condiciones y cobertura de garantía.', url:'/policies/refund-policy' },
    contact:{ icon:'whatsapp', title:'Contactar a BOX', text:'Escríbenos para recibir atención personalizada.', url:'/pages/contactanos' },
    locations:{ icon:'location', title:'Consultar sucursales y ubicación', text:'Te ayudamos a encontrar la opción de atención más conveniente.', url:'/pages/contactanos?motivo=ubicaciones' },
    hours:{ icon:'clock', title:'Consultar horarios de atención', text:'Revisa o confirma nuestros horarios antes de visitarnos.', url:'/pages/contactanos?motivo=horarios' },
    payments:{ icon:'payment', title:'Consultar métodos de pago', text:'Conoce las formas de pago disponibles para tu pedido.', url:'/pages/contactanos?motivo=metodos-de-pago' }
  };

  function serviceCards(query){
    const key = queryInfo(query).service;
    const data = SERVICE_CARD_DATA[key];
    if (!data) return null;
    const primary = {
      key:'service-' + key,
      icon:data.icon,
      strength:'exact',
      badge:'Ayuda',
      title:data.title,
      text:data.text,
      url:data.url + (data.url.includes('?') ? '&' : '?') + 'q=' + encodeParam(query)
    };
    const whatsapp = {
      key:'service-whatsapp',
      icon:'whatsapp',
      strength:'normal',
      badge:'',
      title:'Escríbenos por WhatsApp',
      text:'Servicio al cliente puede orientarte directamente.',
      url:whatsappHelpUrl(query)
    };
    return { cards:[primary, whatsapp], mode:'service' };
  }

  function genericRouteResult(query){
    const q = normalizeQuery(query);
    const intent = queryIntent(query);
    const modelCoreValue = queryModelCore(query);
    const hasModel = /\d/.test(modelCoreValue) || queryLooksLikeDeviceModel(modelCoreValue);
    const cards = [];
    const add = function(card){ if (card && !cards.some(function(c){ return c.key === card.key; })) cards.push(card); };

    const cameraGlassQuery = /\b(glass cam|camara|camera|lente|lens)\b/.test(q);
    const temperedGlassQuery = !cameraGlassQuery && (
      /\b(vidrio templado|protector de vidrio|protector vidrio|vidrio para pantalla|vidrio de pantalla|cristal templado|protector de cristal|tempered glass|glass protector)\b/.test(q) ||
      /\b(vidrio|templado|cristal)\b/.test(q)
    );

    if (temperedGlassQuery){
      return { cards:[featureRouteCard('tempered-glass', query)], mode:'direct' };
    }

    if (/^protector(?:es)?$/.test(q)){
      add({ key:'generic-fundas', icon:'case', title:'Fundas para celulares', text:'Protección exterior según marca, modelo y diseño.', url:'/pages/fundas-celulares' });
      add({ key:'generic-hydrogel', icon:'hydrogel', title:'Hydrogel para pantalla', text:'Protección de pantalla cortada a la medida.', url:'/pages/hydrogel' });
      add({ key:'generic-glasscam', icon:'glass-cam', title:'Glass Cam para cámara', text:'Protectores para la cámara trasera según modelo.', url:'/pages/accesorios?tipo=GLASS%20CAM' });
      return { cards:cards, mode:'routes' };
    }

    if (intent.watch && !hasModel){
      add({ key:'generic-watch', icon:'watch', strength:'exact', badge:'Categoría', title:'Accesorios para SmartWatch', text:'Pulseras, bumpers y combos por medida y modelo.', url:'/pages/accesorios-smartwatch?q=' + encodeParam(query) });
      return { cards:cards, mode:'routes' };
    }

    if (/\b(ldnio|a2317c)\b/.test(q)){
      add({ key:'generic-chargers-ldnio', icon:'cable', strength:'exact', badge:'Categoría', title:'Cargadores y cables LDNIO', text:'Cargadores, cables y cubos compatibles disponibles.', url:'/pages/cargadores-y-cables?q=' + encodeParam(query) });
      return { cards:cards, mode:'routes' };
    }

    if (/\bapple\b/.test(q) && !hasModel && !intent.watch){
      add({ key:'apple-iphone', icon:'case', title:'Fundas para iPhone', text:'Busca el modelo exacto de tu iPhone.', url:'/pages/fundas-celulares?marca=APPLE' });
      add({ key:'apple-ipad', icon:'tablet', title:'Fundas para iPad', text:'Opciones compatibles para iPad y tablets.', url:'/pages/ipads-y-tablets?marca=APPLE' });
      add({ key:'apple-airpods', icon:'airpods', title:'Accesorios para AirPods', text:'Explora protectores y accesorios disponibles.', url:'/pages/accesorios?tipo=AIRPODS' });
      return { cards:cards, mode:'routes' };
    }

    if (SHOW_CUSTOM_CASES && /\bfunda personalizada\b/.test(q)){
      const customModel = displayLabel(queryModelCore(query));
      add({ key:'custom-case', icon:'case', strength:'exact', badge:'Personaliza', title:customModel ? 'Personalizar funda para “' + customModel + '”' : 'Crear una funda personalizada', text:'Elige marca, modelo e imagen para tu diseño.', url:'/pages/fundas-personalizadas' + (customModel ? '?modelo=' + encodeParam(customModel) : '') });
      return { cards:cards, mode:'routes' };
    }
    if (/\bfunda\b/.test(q) && !hasModel){
      add({ key:'generic-fundas', icon:'case', strength:'exact', badge:'Categoría', title:'Fundas para celulares', text:'Elige marca, modelo y diseños compatibles.', url:'/pages/fundas-celulares' });
      add({ key:'generic-tablets', icon:'tablet', title:'Fundas para iPads y tablets', text:'Busca opciones compatibles para tu tablet.', url:'/pages/ipads-y-tablets' });
      if (SHOW_CUSTOM_CASES){
        add({ key:'custom-case', icon:'case', title:'Fundas personalizadas', text:'Crea una funda con tu propia imagen.', url:'/pages/fundas-personalizadas' });
      }
      return { cards:cards, mode:'routes' };
    }
    if (/\bhydrogel\b/.test(q) && !hasModel) return { cards:[featureRouteCard('hydrogel', query)], mode:'routes' };
    if (/\bglass cam\b/.test(q) && !hasModel) return { cards:[featureRouteCard('camera', query)], mode:'routes' };
    if (/\b(airpods|auriculares)\b/.test(q) && !hasModel){
      const isAirpods = /\bairpods\b/.test(q);
      add({ key:'generic-audio', icon:isAirpods ? 'airpods' : 'audio', strength:'exact', badge:'Categoría', title:isAirpods ? 'Accesorios para AirPods' : 'Auriculares disponibles', text:'Explora las opciones disponibles en accesorios.', url:'/pages/accesorios?tipo=' + (isAirpods ? 'AIRPODS' : 'AURICULARES') });
      return { cards:cards, mode:'routes' };
    }
    if (/^accesorios?$/.test(q)){
      add({ key:'generic-accessories', icon:'glass-cam', strength:'exact', badge:'Categoría', title:'Explorar accesorios', text:'AirPods, auriculares, Glass Cam y más.', url:'/pages/accesorios' });
      return { cards:cards, mode:'routes' };
    }
    if (/\b(cargador|cable|cubo)\b/.test(q) && !/\d|tipo c|lightning|v8|usb/.test(q)){
      add({ key:'generic-chargers', icon:'cable', strength:'exact', badge:'Categoría', title:'Cargadores y cables', text:'Cables, cubos, Tipo C, Lightning y V8.', url:'/pages/cargadores-y-cables?q=' + encodeParam(query) });
      return { cards:cards, mode:'routes' };
    }
    return null;
  }

  function buildInstantCards(query){
    return serviceCards(query) || genericRouteResult(query);
  }

  function buildCards(index, query){
    const instant = buildInstantCards(query);
    if (instant) return instant;
    const intent = queryIntent(query);
    const cards = [];
    const exactCards = [];
    const relatedCards = [];
    const addUnique = function(target, card){
      if (!card) return;
      if (!target.some(function(c){ return c.key === card.key; })) target.push(card);
    };

    const phoneMatches = findMatches(index.fundas || [], query, 'fundas');
    const tabletMatches = findMatches(index.tablets || [], query, 'tablets');
    const accMatches = findMatches(index.accesorios || [], query, 'accesorios');
    const watchMatches = findMatches(index.smartwatch || [], query, 'smartwatch');
    const chargerQuery = chargerQueryAlias(query);
    const chargerMatches = findMatches(index.cargadores || [], chargerQuery, 'cargadores');

    if (intent.cable){
      // Para búsquedas de cargadores, conectores o potencia (ej. 40W),
      // solo mostramos resultado si existe coincidencia real en cargadores/cables.
      // Evita inventar fundas o hydrogel para términos que no son modelos.
      if (chargerMatches.length) addUnique(cards, cardForSource('cargadores', null, query));
      else if (queryLooksLikeDeviceModel(queryModelCore(query))) addUnique(cards, { key:'cargadores-orientados', icon:'cable', strength:'normal', badge:'', title:'Buscar cargadores y cables', text:'Elige el conector y la potencia adecuada para tu dispositivo.', url:'/pages/cargadores-y-cables?q=' + encodeParam(query) });
      return { cards: cards, mode:'routes' };
    }

    if (intent.temperedGlass){
      addUnique(cards, featureRouteCard('tempered-glass', query));
      return { cards: cards, mode:'direct' };
    }

    if (intent.hydrogel){
      addUnique(cards, featureRouteCard('hydrogel', query));
      return { cards: cards, mode:'routes' };
    }

    if (intent.camera){
      if (accMatches.length) addUnique(cards, featureRouteCard('camera', query));
      else addUnique(cards, featureRouteCard('camera', query));
      return { cards: cards, mode:'routes' };
    }

    const modelSearch = queryLooksLikeDeviceModel(query);
    if (modelSearch){
      const groups = [
        { key:'fundas', matches:phoneMatches },
        { key:'tablets', matches:tabletMatches },
        { key:'accesorios', matches:accMatches },
        { key:'smartwatch', matches:watchMatches }
      ];
      groups.forEach(function(group){
        sortExactThenRelated(group.matches, query).forEach(function(match){
          const card = cardForSource(group.key, match, query);
          if (!card) return;
          if (match.exact) addUnique(exactCards, card);
          else addUnique(relatedCards, card);
        });
      });

      exactCards.slice(0, 10).forEach(function(c){ addUnique(cards, c); });

      if ((phoneMatches.length || tabletMatches.length) && !intent.watch && !intent.airpods && !intent.auriculares && !intent.camera){
        const hydrogelLabel = suggestedLabelFromMatches(phoneMatches.length ? phoneMatches : tabletMatches, query);
        addUnique(cards, { key:'hydrogel', icon:'hydrogel', strength:(exactCards.length ? 'exact' : 'normal'), badge:(exactCards.length ? 'Más probable' : ''), title:'Hydrogel para “' + displayLabel(hydrogelLabel) + '”', text:'Protección de pantalla a la medida para este modelo.', url:'/pages/hydrogel?modelo_sugerido=' + encodeParam(hydrogelLabel) });
      }

      relatedCards.slice(0, Math.max(0, 12 - cards.length)).forEach(function(c){ addUnique(cards, c); });
      if (cards.length) return { cards: cards.slice(0, 12), mode:(queryInfo(query).corrected ? 'suggestions' : (exactCards.length ? 'models' : 'suggestions')) };

    }

    if (phoneMatches.length){
      const label = topLabels(phoneMatches, query, 1)[0].label || query;
      addUnique(cards, { key:'fundas', icon:'case', title:'Buscar fundas para “' + label + '”', text:'Marca, modelo y diseños compatibles.', url:'/pages/fundas-celulares?modelo=' + encodeParam(label) });
    }
    if (tabletMatches.length){
      const label = topLabels(tabletMatches, query, 1)[0].label || query;
      addUnique(cards, { key:'tablets', icon:'tablet', title:'Buscar fundas para “' + label + '”', text:'Opciones compatibles para iPad o tablet.', url:'/pages/ipads-y-tablets?modelo=' + encodeParam(label) });
    }

    topLabels(accMatches, query, 10).forEach(function(match){ addUnique(cards, cardForSource('accesorios', match, query)); });
    if (watchMatches.length){
      const label = topLabels(watchMatches, query, 1)[0].label || query;
      addUnique(cards, { key:'smartwatch', icon:'watch', title:'Ver SmartWatch para “' + label + '”', text:'Pulseras, bumpers y combos compatibles.', url:'/pages/accesorios-smartwatch?modelo=' + encodeParam(label) });
    }
    if (chargerMatches.length) addUnique(cards, cardForSource('cargadores', null, query));
    if ((phoneMatches.length || tabletMatches.length) && !intent.cable && !intent.watch && !intent.airpods && !intent.auriculares && !intent.camera){
      const hydrogelLabel = suggestedLabelFromMatches(phoneMatches.length ? phoneMatches : tabletMatches, query);
      addUnique(cards, { key:'hydrogel', icon:'hydrogel', strength:'normal', badge:'', title:'Hydrogel para “' + displayLabel(hydrogelLabel) + '”', text:'Protección de pantalla a la medida para este modelo.', url:'/pages/hydrogel?modelo_sugerido=' + encodeParam(hydrogelLabel) });
    }

    /* Respaldo específico para iPads/Tablets:
       si la colección no devuelve coincidencias exactas por modelo, evitamos caer en
       “No encontramos” para búsquedas válidas como ipad, ipad air, tablet o libreta. */
    if (!cards.length && intent.tablet){
      addUnique(cards, { key:'generic-tablets-fallback', icon:'tablet', strength:'exact', badge:'Categoría', title:'Fundas para iPads y Tablets', text:'Busca opciones compatibles para tu iPad o tablet.', url:'/pages/ipads-y-tablets?q=' + encodeParam(query) });
    }

    return { cards:cards.slice(0, 12), mode:'routes' };
  }


  function iconSvg(kind){
    const icons = {
      'case':'<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="8" y="3.5" width="16" height="25" rx="4.5"></rect><path d="M12 8.5h8"></path><path d="M13.5 23.5h5"></path><path d="M24 10.5c1.4 1.1 2.2 2.8 2.2 4.7v1.6c0 1.9-.8 3.7-2.2 4.8"></path></svg>',
      'tablet':'<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="5" y="4" width="22" height="24" rx="3.5"></rect><path d="M13 8h6"></path><path d="M15.4 24.2h1.2"></path><path d="M27 10.5c1.3 1 2 2.5 2 4.2v2.6c0 1.6-.8 3.2-2 4.2"></path></svg>',
      'glass-cam':'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M5 11h22v13a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V11Z"></path><path d="M10.5 11 12.7 7h6.6l2.2 4"></path><circle cx="16" cy="18" r="5"></circle><circle cx="24" cy="14" r="1"></circle></svg>',
      'glass-screen':'<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="8" y="3.5" width="16" height="25" rx="4"></rect><path d="M12 7.5h8M13.5 24.5h5"></path><path d="M5.5 7.5v17"></path><path d="m4 9 1.5-1.5L7 9"></path><path d="m4 23 1.5 1.5L7 23"></path><path d="m12 18 2.2 2.2 5.3-6"></path></svg>',
      'airpods':'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M12 5.5a4 4 0 0 0-4 4v6.4a4 4 0 0 0 2.8 3.8V25"></path><path d="M20 5.5a4 4 0 0 1 4 4v6.4a4 4 0 0 1-2.8 3.8V25"></path><path d="M10.8 14.5h2.6"></path><path d="M18.6 14.5h2.6"></path><path d="M10.8 25h0"></path><path d="M21.2 25h0"></path></svg>',
      'audio':'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M6.5 18v-4.8a5 5 0 0 1 5-5H13l2.5-3h1l2.5 3H20.5a5 5 0 0 1 5 5V18"></path><rect x="5.5" y="17" width="5" height="8" rx="2.5"></rect><rect x="21.5" y="17" width="5" height="8" rx="2.5"></rect><path d="M10.5 24c1.2 1.5 3.1 2.5 5.5 2.5s4.3-1 5.5-2.5"></path></svg>',
      'watch':'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M12 2.8h8l1.3 4.2h-10.6L12 2.8Z"></path><rect x="8" y="7" width="16" height="18" rx="4"></rect><path d="M12 29.2h8l1.3-4.2h-10.6L12 29.2Z"></path><circle cx="16" cy="16" r="4.8"></circle><path d="M16 13.5v3l2.1 1.6"></path></svg>',
      'cable':'<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="4.5" y="8" width="12" height="15.5" rx="3"></rect><path d="M8.2 8V4.2M12.8 8V4.2"></path><path d="M8.5 18.5h4"></path><path d="M16.5 15.5h2.2a5.8 5.8 0 0 1 5.8 5.8v1.4"></path><rect x="21.8" y="22.5" width="5.4" height="5.5" rx="1.2"></rect><path d="M23.5 22.5v-2h2v2"></path></svg>',
      'categories':'<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="3.5" y="4" width="25" height="24" rx="4"></rect><path d="M3.5 10.5h25"></path><circle cx="7.2" cy="7.3" r=".7"></circle><circle cx="10.2" cy="7.3" r=".7"></circle><rect x="7" y="14" width="7" height="5.5" rx="1.4"></rect><rect x="18" y="14" width="7" height="5.5" rx="1.4"></rect><rect x="7" y="22.5" width="7" height="2.5" rx="1.2"></rect><path d="M18.4 22.1 26 25.2l-3.1 1.3-1.3 3.1-3.2-7.5Z"></path></svg>',
      'whatsapp':'<span class="box-smart-wa-icon" aria-hidden="true"></span>',
      'order':'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M7 6h18v21H7z"></path><path d="M11 3h10v6H11z"></path><path d="M11 14h10M11 19h7M11 24h5"></path></svg>',
      'shipping':'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M3 8h17v14H3z"></path><path d="M20 13h5l4 5v4h-9z"></path><circle cx="9" cy="24" r="2.5"></circle><circle cx="24" cy="24" r="2.5"></circle></svg>',
      'shield':'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 3 27 7v8c0 7-4.4 11.8-11 14-6.6-2.2-11-7-11-14V7z"></path><path d="m11 16 3 3 7-8"></path></svg>',
      'location':'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M25 13c0 7-9 16-9 16S7 20 7 13a9 9 0 1 1 18 0Z"></path><circle cx="16" cy="13" r="3"></circle></svg>',
      'clock':'<svg viewBox="0 0 32 32" aria-hidden="true"><circle cx="16" cy="16" r="12"></circle><path d="M16 9v8l5 3"></path></svg>',
      'payment':'<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="3" y="7" width="26" height="18" rx="3"></rect><path d="M3 12h26M8 20h7"></path></svg>',
      'hydrogel':'<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="9" y="3.5" width="14" height="25" rx="3.8"></rect><path d="M13 8h6"></path><path d="M11.8 19.2 14.5 16l2.4 2.5 4-5"></path><path d="M23 8.5c1.5 1.2 2.4 3 2.4 5v4c0 2-.9 3.8-2.4 5"></path></svg>'
    };
    return icons[kind] || icons['case'];
  }


  function iconTone(kind){
    switch(kind){
      case 'hydrogel': return 'hydrogel';
      case 'glass-cam': return 'glasscam';
      case 'glass-screen': return 'glasscam';
      case 'airpods': return 'airpods';
      case 'audio': return 'audio';
      case 'watch': return 'smartwatch';
      case 'cable': return 'cargadores';
      case 'whatsapp': return 'whatsapp';
      case 'shipping': return 'hydrogel';
      case 'shield': return 'glasscam';
      case 'order': return 'cargadores';
      case 'location': return 'smartwatch';
      case 'clock': return 'airpods';
      case 'payment': return 'cargadores';
      case 'categories': return 'fundas';
      case 'tablet': return 'tablets';
      default: return 'fundas';
    }
  }


  function whatsappHelpUrl(query){
    return 'https://wa.me/50237945464?text=' + encodeParam('Hola BOX, necesito ayuda para encontrar el producto correcto. Busqué: "' + String(query || '').trim() + '".');
  }
  function noResultsCardsHtml(query){
    return '<div class="box-smart-grid">' +
      '<a class="box-smart-card box-smart-card--tone-whatsapp box-smart-card--exact" href="' + escapeHtml(whatsappHelpUrl(query)) + '" target="_blank" rel="noopener">' +
        '<span class="box-smart-card__icon" aria-hidden="true">' + iconSvg('whatsapp') + '</span>' +
        '<span><span class="box-smart-card__badge">Ayuda rápida</span><span class="box-smart-card__title">Escríbenos por WhatsApp</span><span class="box-smart-card__text">Te ayudamos a confirmar modelo, compatibilidad o disponibilidad.</span></span>' +
        '<span class="box-smart-card__arrow" aria-hidden="true">›</span>' +
      '</a>' +
      '<a class="box-smart-card box-smart-card--tone-fundas" href="/pages/contactanos?q=' + encodeParam(query) + '">' +
        '<span class="box-smart-card__icon" aria-hidden="true">' + iconSvg('case') + '</span>' +
        '<span><span class="box-smart-card__title">No estoy seguro de mi modelo</span><span class="box-smart-card__text">Déjanos tu consulta y te orientamos antes de comprar.</span></span>' +
        '<span class="box-smart-card__arrow" aria-hidden="true">›</span>' +
      '</a>' +
      '<a class="box-smart-card box-smart-card--tone-fundas" href="/">' +
        '<span class="box-smart-card__icon" aria-hidden="true">' + iconSvg('categories') + '</span>' +
        '<span><span class="box-smart-card__title">Ver categorías principales</span><span class="box-smart-card__text">Explora fundas, hydrogel, accesorios, SmartWatch y cargadores.</span></span>' +
        '<span class="box-smart-card__arrow" aria-hidden="true">›</span>' +
      '</a>' +
    '</div>';
  }
  function noResultsPageCardsHtml(query){
    return '<div class="box-search-routes__grid">' +
      '<a class="box-search-routes__card box-search-routes__card--tone-whatsapp box-search-routes__card--exact" href="' + escapeHtml(whatsappHelpUrl(query)) + '" target="_blank" rel="noopener">' +
        '<span class="box-search-routes__icon" aria-hidden="true">' + iconSvg('whatsapp') + '</span>' +
        '<span><span class="box-search-routes__badge">Ayuda rápida</span><span class="box-search-routes__heading">Escríbenos por WhatsApp</span><span class="box-search-routes__desc">Te ayudamos a confirmar modelo, compatibilidad o disponibilidad.</span></span>' +
        '<span class="box-search-routes__arrow" aria-hidden="true">›</span>' +
      '</a>' +
      '<a class="box-search-routes__card box-search-routes__card--tone-fundas" href="/pages/contactanos?q=' + encodeParam(query) + '">' +
        '<span class="box-search-routes__icon" aria-hidden="true">' + iconSvg('case') + '</span>' +
        '<span><span class="box-search-routes__heading">No estoy seguro de mi modelo</span><span class="box-search-routes__desc">Déjanos tu consulta y te orientamos antes de comprar.</span></span>' +
        '<span class="box-search-routes__arrow" aria-hidden="true">›</span>' +
      '</a>' +
      '<a class="box-search-routes__card box-search-routes__card--tone-fundas" href="/">' +
        '<span class="box-search-routes__icon" aria-hidden="true">' + iconSvg('categories') + '</span>' +
        '<span><span class="box-search-routes__heading">Ver categorías principales</span><span class="box-search-routes__desc">Explora fundas, hydrogel, accesorios, SmartWatch y cargadores.</span></span>' +
        '<span class="box-search-routes__arrow" aria-hidden="true">›</span>' +
      '</a>' +
    '</div>';
  }

  function loadingHtml(query){
    return '<div class="box-smart-results">' +
      '<h2 class="box-smart-results__heading">Buscando opciones para ti</h2>' +
      '<p class="box-smart-results__note">Estamos buscando opciones compatibles con “' + escapeHtml(query) + '”.</p>' +
      '</div>';
  }
  function resultsHtml(result, query){
    const cards = result.cards || [];
    if (!cards.length){
      return '<div class="box-smart-results">' +
        '<h2 class="box-smart-results__heading">No encontramos una opción compatible</h2>' +
        '<p class="box-smart-results__note">Prueba escribir el modelo completo o el tipo de producto. Ejemplos: “Galaxy S25 Ultra”, “iPhone 15 Pro Max”, “AirPods”, “Watch 45 mm”, “Tipo C” o “Cargador 20W”.</p>' +
        noResultsCardsHtml(query) +
        '</div>';
    }
    const heading = result.mode === 'models' ? 'Encuentra la opción correcta para tu modelo' : (result.mode === 'suggestions' ? 'Quizás estás buscando' : (result.mode === 'service' ? 'Te ayudamos con tu consulta' : (result.mode === 'direct' ? 'Encontramos esta opción' : 'Elige dónde quieres buscar')));
    const note = result.mode === 'models'
      ? '<p class="box-smart-results__note">Selecciona la opción que mejor coincida con lo que estás buscando.</p>'
      : (result.mode === 'suggestions'
        ? '<p class="box-smart-results__note">Encontramos opciones parecidas a lo que escribiste. Elige una sugerencia para continuar.</p>'
        : (result.mode === 'service' ? '<p class="box-smart-results__note">Selecciona la opción adecuada o escríbenos para recibir ayuda.</p>' : ''));
    return '<div class="box-smart-results">' +
      '<h2 class="box-smart-results__heading">' + heading + '</h2>' + note +
      '<div class="box-smart-grid">' + cards.map(function(card){
        const exactClass = card.strength === 'exact' ? ' box-smart-card--exact' : '';
        const toneClass = ' box-smart-card--tone-' + iconTone(card.icon);
        const badge = card.badge ? '<span class="box-smart-card__badge">' + escapeHtml(card.badge) + '</span>' : '';
        return '<a class="box-smart-card' + exactClass + toneClass + '" href="' + escapeHtml(card.url) + '">' +
          '<span class="box-smart-card__icon" aria-hidden="true">' + iconSvg(card.icon) + '</span>' +
          '<span>' + badge + '<span class="box-smart-card__title">' + escapeHtml(card.title) + '</span>' +
          '<span class="box-smart-card__text">' + escapeHtml(card.text) + '</span></span>' +
          '<span class="box-smart-card__arrow" aria-hidden="true">›</span>' +
        '</a>';
      }).join('') + '</div></div>';
  }

  function wireSmartSearch(form){
    const input = form.querySelector('input[type="search"][name="q"]');
    const box = form.querySelector('[data-box-smart-panel]');
    const resetBtn = form.querySelector('.reset__button');
    if (!input || !box || input.dataset.boxSmartBound === '1') return;
    input.dataset.boxSmartBound = '1';
    let timer = null;
    let activeToken = 0;
    let rendering = false;

    function clearResults(){
      activeToken++;
      clearTimeout(timer);
      rendering = true;
      box.innerHTML = '';
      box.setAttribute('hidden', 'hidden');
      box.style.display = 'none';
      rendering = false;
    }

    async function render(){
      const query = input.value.trim();
      const token = ++activeToken;

      if (query.length < MIN_CHARS){
        rendering = true;
        box.innerHTML = '';
        box.setAttribute('hidden', 'hidden');
        box.style.display = 'none';
        rendering = false;
        return;
      }

      const instant = buildInstantCards(query);
      if (instant){
        rendering = true;
        box.innerHTML = resultsHtml(instant, query);
        box.removeAttribute('hidden');
        box.style.display = 'block';
        rendering = false;
        return;
      }

      let loadingTimer = setTimeout(function(){
        if (token !== activeToken || input.value.trim() !== query) return;
        rendering = true;
        box.innerHTML = loadingHtml(query);
        box.removeAttribute('hidden');
        box.style.display = 'block';
        rendering = false;
      }, LOADING_DELAY_MS);

      try{
        let index = await getIndex(false);
        if (token !== activeToken || input.value.trim() !== query) return;
        let result = buildCards(index, query);

        // Si el caché o una carga parcial dejó el índice incompleto, reintentamos una vez
        // con datos frescos antes de mostrar que no hay opción compatible.
        if ((!result.cards || !result.cards.length) && query.length >= MIN_CHARS){
          try{ localStorage.removeItem(CACHE_KEY); }catch(e){}
          index = await getIndex(true);
          if (token !== activeToken || input.value.trim() !== query) return;
          result = buildCards(index, query);
        }

        clearTimeout(loadingTimer);
        if (token !== activeToken || input.value.trim() !== query) return;
        rendering = true;
        box.innerHTML = resultsHtml(result, query);
        box.removeAttribute('hidden');
        box.style.display = 'block';
        rendering = false;
      }catch(e){
        clearTimeout(loadingTimer);
        if (token !== activeToken || input.value.trim() !== query) return;
        rendering = true;
        box.innerHTML = resultsHtml({ cards: [] }, query);
        box.removeAttribute('hidden');
        box.style.display = 'block';
        rendering = false;
      }
    }

    function schedule(){
      clearTimeout(timer);
      const query = input.value.trim();
      if (query.length < MIN_CHARS){ clearResults(); return; }
      timer = setTimeout(render, 90);
    }

    input.addEventListener('input', schedule);
    input.addEventListener('focus', function(){
      // No descarga catálogos durante la carga inicial. El precalentamiento ocurre
      // solo al enfocar la búsqueda y cuando el navegador dispone de tiempo libre.
      const preheat = function(){
        if (document.activeElement === input && input.value.trim().length < MIN_CHARS) getIndex(false).catch(function(){});
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(preheat, { timeout:1200 });
      else setTimeout(preheat, PREHEAT_DELAY_MS);
      if(input.value.trim().length >= MIN_CHARS) schedule();
    });
    resetBtn && resetBtn.addEventListener('click', function(){ setTimeout(clearResults, 0); });

    const observer = new MutationObserver(function(){
      if (rendering) return;
      if (input.value.trim().length >= MIN_CHARS && !box.querySelector('.box-smart-results')) schedule();
    });
    observer.observe(box, { childList:true, subtree:false });
  }

  async function renderPageRoutes(el){
    const query = (el.getAttribute('data-query') || '').trim();
    if (!query) return;
    const instant = buildInstantCards(query);
    if (instant){
      const heading = instant.mode === 'service' ? 'Te ayudamos con tu consulta' : '¿Dónde quieres buscar?';
      const note = instant.mode === 'service' ? 'Selecciona la opción adecuada o escríbenos para recibir ayuda.' : 'Estos accesos te llevan directo a la página correcta según lo que escribiste.';
      el.innerHTML = '<div class="box-search-routes__inner"><h2 class="box-search-routes__title">' + escapeHtml(heading) + '</h2><p class="box-search-routes__text">' + escapeHtml(note) + '</p><div class="box-search-routes__grid">' +
        instant.cards.map(function(card){
          const exactClass = card.strength === 'exact' ? ' box-search-routes__card--exact' : '';
          const toneClass = ' box-search-routes__card--tone-' + iconTone(card.icon);
          const badge = card.badge ? '<span class="box-search-routes__badge">' + escapeHtml(card.badge) + '</span>' : '';
          return '<a class="box-search-routes__card' + exactClass + toneClass + '" href="' + escapeHtml(card.url) + '"><span class="box-search-routes__icon" aria-hidden="true">' + iconSvg(card.icon) + '</span><span>' + badge + '<span class="box-search-routes__heading">' + escapeHtml(card.title) + '</span><span class="box-search-routes__desc">' + escapeHtml(card.text) + '</span></span><span class="box-search-routes__arrow" aria-hidden="true">›</span></a>';
        }).join('') + '</div></div>';
      return;
    }
    el.innerHTML = '<div class="box-search-routes__inner"><h2 class="box-search-routes__title">Buscando opciones para ti</h2><p class="box-search-routes__text">Estamos buscando opciones compatibles con “' + escapeHtml(query) + '”.</p></div>';
    let index = await getIndex(false);
    let result = buildCards(index, query);
    if ((!result.cards || !result.cards.length) && query.length >= MIN_CHARS){
      try{ localStorage.removeItem(CACHE_KEY); }catch(e){}
      index = await getIndex(true);
      result = buildCards(index, query);
    }
    const heading = result.mode === 'models' ? 'Encuentra la opción correcta para tu modelo' : (result.mode === 'suggestions' ? 'Quizás estás buscando' : (result.mode === 'service' ? 'Te ayudamos con tu consulta' : (result.mode === 'direct' ? 'Encontramos esta opción' : '¿Dónde quieres buscar?')));
    const note = result.mode === 'models'
      ? 'Selecciona la opción que mejor coincida con lo que estás buscando.'
      : (result.mode === 'suggestions'
        ? 'Encontramos opciones parecidas a lo que escribiste. Elige una sugerencia para continuar.'
        : (result.mode === 'service' ? 'Selecciona la opción adecuada o escríbenos para recibir ayuda.' : 'Estos accesos te llevan directo a la página correcta según lo que escribiste.'));
    if (!result.cards.length){
      el.innerHTML = '<div class="box-search-routes__inner"><h2 class="box-search-routes__title">No encontramos una opción compatible</h2><p class="box-search-routes__text">Prueba escribir el modelo completo o el tipo de producto. Ejemplos: “Galaxy S25 Ultra”, “iPhone 15 Pro Max”, “AirPods”, “Watch 45 mm”, “Tipo C” o “Cargador 20W”.</p>' + noResultsPageCardsHtml(query) + '</div>';
      return;
    }
    el.innerHTML = '<div class="box-search-routes__inner"><h2 class="box-search-routes__title">' + escapeHtml(heading) + '</h2><p class="box-search-routes__text">' + escapeHtml(note) + '</p><div class="box-search-routes__grid">' +
      result.cards.map(function(card){
        const exactClass = card.strength === 'exact' ? ' box-search-routes__card--exact' : '';
        const toneClass = ' box-search-routes__card--tone-' + iconTone(card.icon);
        const badge = card.badge ? '<span class="box-search-routes__badge">' + escapeHtml(card.badge) + '</span>' : '';
        return '<a class="box-search-routes__card' + exactClass + toneClass + '" href="' + escapeHtml(card.url) + '"><span class="box-search-routes__icon" aria-hidden="true">' + iconSvg(card.icon) + '</span><span>' + badge + '<span class="box-search-routes__heading">' + escapeHtml(card.title) + '</span><span class="box-search-routes__desc">' + escapeHtml(card.text) + '</span></span><span class="box-search-routes__arrow" aria-hidden="true">›</span></a>';
      }).join('') + '</div></div>';
  }

  function boot(){
    document.querySelectorAll('.header__search form.search, .search-modal form.search').forEach(wireSmartSearch);
    document.querySelectorAll('[data-box-smart-search]:not([data-box-smart-rendered])').forEach(function(el){
      el.setAttribute('data-box-smart-rendered','1');
      renderPageRoutes(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
